import request from '@/utils/request'

//含有参数的和返回值的post请求，如登录请求接口
export const login = async (params) => {
  const res = await request.post('/acc/login', params)
  if (res.code === 200) {
    return res.data
  }
  return Promise.reject(res.message)
}